import React from 'react'
import { currency } from '../../../../../common/services/common.service';
import { FileUploadComponent } from './file-upload.component';

export default function ModalEwayComponent({ handleFileURlSubmit,
    selectedVehicleItem, dropLocations, pickupLocations, quoteDetails }: any) {

    return (


        <div className="w-full p-4 bg-white ">
            <h1 className="text-xl font-semibold mb-4 text-center">Confirm Order</h1>

            {/* Order Details */}
            <div>
                <h2 className=" px-4 text-lg font-semibold mb-4">Order Details</h2>
                <div className="grid grid-cols-3 gap-4  px-4">
                    <div>
                        <label className="text-base font-medium text-gray-800">Vehicle Type</label>
                        <p className="text-sm font-medium text-gray-600">{selectedVehicleItem?.VehicleType}</p>
                    </div>
                    <div>
                        <label className="text-base font-medium text-gray-800">Total Distance</label>
                        <p className="text-sm font-medium text-gray-600">{quoteDetails?.result?.Records[0]?.message?.order?.quote?.TotalDistance} km</p>
                    </div>
                    <div>
                        <label className="text-base font-medium text-gray-800">Amount Quoted</label>
                        <p className="text-sm font-medium text-gray-600">{currency(quoteDetails?.result?.Records[0]?.message?.order?.quote?.price?.value)}</p>
                    </div>

                </div>
                <div className="border-b border-gray-300 py-2" />
                <div className="grid grid-cols-1 gap-4 pt-2 px-4">

                    <div>
                        <label className="text-base font-medium text-gray-800">Pickup Address</label>
                        <p className="text-sm font-medium text-gray-600">{pickupLocations?.description}</p>
                    </div>
                    <div>
                        <label className="text-base font-medium text-gray-800">Drop Address</label>
                        <p className="text-sm font-medium text-gray-600">{dropLocations?.description}</p>
                    </div>
                </div>
                <div className="border-b border-gray-300 py-2" />
            </div>
            <div className="p-4">
                {/* Upload E-way Bill */}
                <h2 className="text-lg font-semibold mb-4">E-way Bill Details</h2>
                <p className="text-base font-medium text-gray-800">Upload the E-way Bill</p>
                <div>
                    <FileUploadComponent handleFileURlSubmit={handleFileURlSubmit} />
                </div>
            </div>
        </div>



    )
}